<template>
  <hm-content :hidden="hidden">
    <div class="table-panel">
      <!-- <el-select
        filterable
        clearable
        size="small"
        style="width:200px"
        class="mr10 flex-1"
        v-model="searchCondition.overstockSales"
        placeholder="请选择方案名称"
      >
        <el-option label="已开启" value="open"></el-option>
        <el-option label="未开启" value="close"></el-option>
      </el-select> -->
      <el-input
        clearable
        v-model.trim="searchCondition.planName"
        placeholder="请输入方案名称"
        size="small"
        style="width:200px"
        class="ipt mr10"
      ></el-input>
      <el-date-picker
        clearable
        :default-time="['00:00:00', '23:59:59']"
        v-model="searchCondition.createTimeArry"
        type="datetimerange"
        align="right"
        start-placeholder="请选择销售开始时间筛选"
        end-placeholder="请选择结销售束时间筛选"
        value-format="yyyy-MM-dd HH:mm:ss"
        size="small"
        class="mr10"
      ></el-date-picker>
      <el-cascader
        v-model="searchCondition.categoryId"
        :show-all-levels="false"
        size="small"
        class="mr10 flex-1"
        :props="categoryFuncs"
        clearable
        placeholder="请选择类目"
      ></el-cascader>
      <el-select
        filterable
        clearable
        size="small"
        class="mr10 flex-1"
        v-model="searchCondition.brandId"
        placeholder="请选择商品品牌"
      >
        <el-option
          :label="v.brandName"
          :value="v.brandId"
          v-for="(v, i) in allBrandList"
          :key="i"
        ></el-option>
      </el-select>
      <el-input
        clearable
        v-model.trim="searchCondition.orderId"
        placeholder="请输入订单号"
        size="small"
        style="width:200px"
        class="ipt mr10"
      ></el-input>
      <el-select
        filterable
        clearable
        size="small"
        class="mr10 flex-1"
        v-model="searchCondition.shopId"
        placeholder="请选择门店"
      >
        <el-option
          :label="v.name"
          :value="v.id"
          v-for="(v, i) in shopList"
          :key="i"
        ></el-option>
      </el-select>
    </div>
    <div class="table-panel">
      <el-input
        clearable
        style="width:300px"
        v-model.trim="searchCondition.queryMemberWord"
        :placeholder="placeholderMember"
        size="small"
        class="ipt mr10"
      >
        <el-select
          slot="prepend"
          size="small"
          style="width:120px"
          @change="selectQueryMember"
          v-model="searchCondition.queryMemberType"
        >
          <el-option label="会员手机号" value="memberPhone"></el-option>
          <el-option label="会员卡号" value="memberNo"></el-option>
        </el-select>
      </el-input>
      <el-input
        clearable
        style="width:300px"
        v-model.trim="searchCondition.queryGuiderWord"
        :placeholder="placeholderGuider"
        size="small"
        class="ipt mr10"
      >
        <el-select
          slot="prepend"
          size="small"
          style="width:100px"
          @change="selectQueryGuider"
          v-model="searchCondition.queryGuiderType"
        >
          <el-option label="导购工号" value="workNum"></el-option>
          <el-option label="导购姓名" value="workName"></el-option>
        </el-select>
      </el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button type="success" size="small" @click="dialogVisibleOutput = true"
        >生成报表</el-button
      >
      <!-- <el-button
        type="success"
        size="small"
        @click="output('queryAllList', '导购个人奖励')"
        :loading="isOutputing"
        >导出</el-button
      > -->
    </div>
    <div class="flex flex-wrap totalPrice">
      <div class="mr20">总销售金额：{{ totalSaleMoney }}</div>
      <div>总提成金额:{{ totalRewardMoney }}</div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderId"
          label="订单号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="saleTime"
          label="订单时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsName"
          label="商品名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="品类"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="brandName"
          label="品牌"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="saleNum"
          label="销售数量"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="saleMoney"
          label="销售金额"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="workNum"
          label="员工工号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="workName"
          label="员工姓名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="rewardMoney"
          label="提成金额"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="planName"
          label="方案名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="planCode"
          label="方案编码"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberNo"
          label="会员卡号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberPhone"
          label="会员手机"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="会员姓名"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="true"
      title="生成报表"
      :visible.sync="dialogVisibleOutput"
    >
      <div class="flex flex-center">
        <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          class="mr10"
          size="small"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchOutputCondition.date"
          type="daterange"
          range-separator="至"
          start-placeholder="请选择时间段"
          end-placeholder="请选择时间段"
        ></el-date-picker>
        <el-button type="success" size="small" @click="output"
          >生成报表</el-button
        >
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      dialogVisibleOutput: false,
      selectDate: "",
      //日期选择范围在一个月内
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = "";
          }
        },
        disabledDate: time => {
          if (this.selectDate !== "") {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      },
      hidden: true,
      searchOutputCondition: {},
      totalRewardMoney: 0,
      totalSaleMoney: 0,
      list: [{}],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      isOutputing: false,
      placeholderMember: "请输入会员手机号",
      placeholderGuider: "请输入导购工号",
      shopList: [],
      allBrandList: [],
      searchCondition: {
        queryMemberType: "memberPhone",
        queryGuiderType: "workNum"
      },
      categoryFuncs: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryAllBrand();
    this.queryAllShopIdList();
  },
  methods: {
    async queryAllShopIdList() {
      const { result } = await this.$store.dispatch("queryOnlineMallStoreList");

      this.shopList = result;
    },
    async queryAllBrand() {
      const { result } = await this.$store.dispatch("queryBrandAllList", {
        pageSize: 999999,
        pageNo: 1
      });
      this.allBrandList = result.records;
    },
    selectQueryMember(queryType) {
      if (queryType === "memberMobile") {
        this.placeholderMember = "请输入会员手机号";
      } else if (queryType === "cardNo") {
        this.placeholderMember = "请输入会员卡号";
      }
    },
    selectQueryGuider(queryType) {
      if (queryType === "guiderNo") {
        this.placeholderGuider = "请输入导购工号";
      } else if (queryType === "guiderName") {
        this.placeholderGuider = "请输入导购姓名";
      }
    },
    search() {
      if (
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
      ) {
        this.currentPage = 1;
        this.queryList();
      } else {
        this.$message({
          type: "warning",
          message: "请选择销售时段"
        });
      }
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // searchCondition.status =
      //   searchCondition.status === "all" ? "" : searchCondition.status;

      searchCondition.categoryId = this.isArray(searchCondition.categoryId)
        ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
        : searchCondition.categoryId;

      // searchCondition.attributeId = this.isArray(searchCondition.attributeId)
      //   ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
      //   : "";
      searchCondition.startTime = this.searchCondition.createTimeArry[0];

      searchCondition.endTime = this.searchCondition.createTimeArry[1];

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch("rewardList", params);
      const { totalRewardMoney, totalSaleMoney, page } = result;
      const { records, total } = page;
      this.totalRewardMoney = totalRewardMoney;
      this.totalSaleMoney = totalSaleMoney;
      this.list = records;
      this.total = total;
    },
    async queryAllList() {
      let params = {
        pageNo: 1,
        pageSize: 99999
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // searchCondition.status =
      //   searchCondition.status === "all" ? "" : searchCondition.status;

      searchCondition.categoryId = this.isArray(searchCondition.categoryId)
        ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
        : searchCondition.categoryId;

      // searchCondition.attributeId = this.isArray(searchCondition.attributeId)
      //   ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
      //   : "";
      searchCondition.startTime = this.searchCondition.createTimeArry[0];

      searchCondition.endTime = this.searchCondition.createTimeArry[1];

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch("rewardAllList", params);
      return result.page.records;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    // 导出excel
    output() {
      if (this.isArray(this.searchOutputCondition.date)) {
        setTimeout(() => {
          this.$message({
            message: "已加入导出队列正在生成报表，请在导出列队中查看！",
            type: "success"
          });
          this.hidden = false;
        }, 0);
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchOutputCondition)
        );

        searchCondition.startTime = this.searchOutputCondition.date[0];

        searchCondition.endTime = this.searchOutputCondition.date[1];

        this.$store.dispatch("exportGuiderReward", searchCondition);
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped>
.totalPrice {
  color: #000;
  font-size: 16px;
  font-weight: 600;
}
</style>
